import { CheckCircle2, Flame, Trophy } from "lucide-react";

export function StreakBadge({ days, testid }) {
  if (!days || days < 2) return null;
  return (
    <span data-testid={testid} className="inline-flex items-center gap-0.5 rounded-full bg-gradient-to-r from-[#F97316] to-[#EA580C] px-1.5 py-0.5 text-[9px] font-extrabold uppercase not-italic tracking-wide text-white shadow-sm">
      <Flame className="h-2.5 w-2.5" /> {days} day streak
    </span>
  );
}

function PassItem({ it }) {
  return (
    <div data-testid={`pass-item-${it.category_id}`} className="pop-in flex items-start gap-2 rounded-xl border border-emerald-600/30 bg-white/80 px-3 py-2 shadow-sm">
      <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" />
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center justify-between gap-x-2">
          <p className="font-display text-sm font-extrabold uppercase text-[#3B0A12]">{it.category_name}</p>
          <p className="font-mono text-sm font-extrabold text-[#7A1020]">{it.result}</p>
        </div>
        <div className="mt-1 flex flex-wrap items-center gap-1">
          {it.passes.map((p) => (
            <span key={p} className="rounded-md bg-emerald-600 px-1.5 py-0.5 text-[10px] font-extrabold text-white">{p} ✓</span>
          ))}
        </div>
      </div>
    </div>
  );
}

export function PassBoard({ data }) {
  const items = data?.items || [];
  if (!items.length) return null;
  return (
    <section data-testid="pass-board" className="mb-8 overflow-hidden rounded-2xl border-2 border-emerald-600 bg-gradient-to-b from-[#ECFDF3] to-[#FFF8E6] shadow">
      <div className="live-fx flex items-center justify-center gap-2 px-4 py-2">
        <Trophy className="h-4 w-4 text-yellow-300" />
        <p className="text-xs font-extrabold uppercase tracking-widest text-white">Today's Pass</p>
        <span data-testid="pass-board-count" className="rounded-full bg-white/20 px-2 py-0.5 text-[10px] font-bold text-white">{items.length} market</span>
      </div>
      <div className="grid grid-cols-1 gap-2 p-3 sm:grid-cols-2">
        {items.map((it) => <PassItem key={it.category_id} it={it} />)}
      </div>
    </section>
  );
}
